<template>
  <div class="mangement_page">
    <div style="display: flex; align-items: center">
      <div>
        <h2>{{ userInfo.company }}-{{ yearNow }}年度内部培训</h2>
        <!-- <a-button>培训目标管理</a-button>
        <a-button>课程类别管理</a-button> -->
      </div>
      <div class="flex_box" style="margin-left: 80px">
        <h3 style="margin-right: 10px">培训完成率</h3>
        <div class="showRate flex_box">
          <div
            class="rate50"
            :style="{ transform: 'rotate(' + (completeRate < 50 ? completeRate * 3.6 : 50 * 3.6) + 'deg)' }"
          ></div>
          <div
            class="rate100"
            :style="{
              transform: 'rotate(' + (completeRate > 50 ? completeRate * 3.6 : 0) + 'deg)',
              background: completeRate > 50 ? '#38b8f2' : '',
            }"
          ></div>
          <div class="rateText flex_box">{{ completeRate }}%</div>
        </div>
      </div>
      <div class="flex_box" style="margin-left: 40px">
        <h3 style="margin-right: 10px">考核通过率</h3>
        <div class="showRate flex_box">
          <div
            class="rate50"
            :style="{ transform: 'rotate(' + (passRate < 50 ? passRate * 3.6 : 50 * 3.6) + 'deg)' }"
          ></div>
          <div
            class="rate100"
            :style="{
              transform: 'rotate(' + (passRate > 50 ? (passRate > 100 ? 100 * 3.6 : passRate * 3.6) : 0) + 'deg)',
              background: passRate > 50 ? '#38b8f2' : '',
            }"
          ></div>
          <div class="rateText flex_box">{{ passRate }}%</div>
        </div>
      </div>
      <div class="flex_box" style="margin-left: 40px" v-if="userRole == 'youwei_admin'">
        <a-button type="primary" @click="showMoreRate" size="small">
          <a-icon type="dash" />
        </a-button>
      </div>
    </div>
    <div style="margin: 10px 0">
      <a-row type="flex">
        <a-col :flex="4">
          <span>部门：</span>
          <a-tree-select
            style="width: 210px; margin-right: 10px"
            v-model="searchInfo.deptIds"
            allowClear
            :treeData="deptLists"
            tree-checkable
            :show-checked-strategy="SHOW_PARENT"
            placeholder="请选择"
            :replaceFields="options"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            maxTagCount="3"
            v-if="userRole == 'youwei_admin'"
          >
          </a-tree-select>
          <a-tree-select
            style="width: 210px; margin-right: 10px"
            v-model="searchInfo.deptId"
            allowClear
            :treeData="deptLists"
            :show-checked-strategy="SHOW_PARENT"
            placeholder="请选择"
            :replaceFields="options"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            maxTagCount="1"
            @change="deptchange"
            :disable-branch-nodes="true"
            dropdownClassName="deptSelectDrop"
            v-else
          >
          </a-tree-select>
        </a-col>
        <a-col :flex="4">
          <span>人员：</span>
          <a-select
            v-model="searchInfo.userId"
            placeholder="人员"
            style="width: 160px; margin-right: 10px"
            showSearch
            optionFilterProp="label"
          >
            <a-select-option :value="item.userId" :label="item.userName" v-for="item in userLis" :key="item.userId">
              {{ item.userName }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :flex="4">
          <a-button type="primary" @click="search_lis"> 查询 </a-button>
          <a-button @click="refresh"> 重置 </a-button>
        </a-col>
      </a-row>
    </div>
    <div style="margin-bottom: 10px; height: calc(100% - 204px)" ref="mainTable">
      <a-table :data-source="dataLis" :scroll="{ y: tableScrollY }" :pagination="false" rowKey="userId">
        <a-table-column title="部门" dataIndex="deptName"> </a-table-column>
        <a-table-column title="用户名" dataIndex="userName"> </a-table-column>
        <a-table-column title="目标学时" dataIndex="targetHours"> </a-table-column>
        <a-table-column title="完成学时" dataIndex="accomplishHours"></a-table-column>
        <a-table-column title="截止时间" dataIndex="deadline">
          <template slot-scope="text">
            {{ text ? text.split(' ')[0] : '' }}
          </template>
        </a-table-column>
        <a-table-column title="操作" dataIndex="userId">
          <template slot-scope="text, record">
            <a-button type="link" @click="detailView(record)"> 详情 </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <div>
      <a-pagination
        show-size-changer
        :default-current="1"
        :total="totalCount"
        :page-size.sync="searchInfo.pageSize"
        @change="onShowPageChange"
        show-quick-jumper
      />
    </div>
    <a-modal v-model="detailInfoShow" title="员工培训情况" width="60%" :footer="null">
      <div class="flex_bet">
        <h3>部门：{{ detail_info.userInfo.deptName }}</h3>
        <h3>姓名：{{ detail_info.userInfo.userName }}</h3>
        <h3>总目标学时：{{ detail_info.userInfo.targetHours }}</h3>
      </div>
      <a-table
        style="margin-bottom: 20px"
        :data-source="detail_info.courseInfo"
        bordered
        :scroll="{ y: 300 }"
        :pagination="false"
        rowKey="courseId"
      >
        <a-table-column title="已选课程" dataIndex="courseInfo.courseName"> </a-table-column>
        <a-table-column title="是否必修" dataIndex="courseInfo.recommend">
          <template slot-scope="text">
            {{ text == 0 ? '否' : '是' }}
          </template>
        </a-table-column>
        <a-table-column title="完成进度" dataIndex="schedule">
          <template slot-scope="text"> {{ text }}% </template>
        </a-table-column>
      </a-table>
      <a-table :data-source="detail_info.examInfo" :scroll="{ y: 300 }" :pagination="false" bordered rowKey="examId">
        <a-table-column title="已生成考试" dataIndex="examName"> </a-table-column>
        <a-table-column title="历次考核分数" dataIndex="examList"></a-table-column>
        <a-table-column title="通过情况" dataIndex="status">
          <template slot-scope="text">
            {{ text == 0 ? '未开始' : text == 1 ? '未通过' : text == 2 ? '已通过' : '' }}
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
    <a-modal v-model="rateVisible" title="内部培训详情" width="60%" :footer="null">
      <a-table
        style="margin-bottom: 20px"
        :data-source="rate_lis"
        bordered
        :scroll="{ y: 500 }"
        :pagination="false"
        rowKey="deptId"
      >
        <a-table-column title="公司" dataIndex="companyName"> </a-table-column>
        <a-table-column title="培训完成率" dataIndex="completeRate"></a-table-column>
        <a-table-column title="考核通过率" dataIndex="passRate"></a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { manage_getrate, manage_getlist, getTrainingDetail, manage_more_getrate } from '../../../api/course'
import { tree_all } from '../../../api/purchase'
export default {
  data() {
    return {
      searchInfo: {
        deptId: undefined,
        deptIds: undefined,
        userId: undefined,
        pageIndex: 1,
        pageSize: 10, // 每页条数
      },
      dataLis: [],
      tableScrollY: '',
      deptLists: [],
      userLis: [],
      totalCount: 0,
      completeRate: 0,
      passRate: 0,
      userInfo: '',
      yearNow: new Date().getFullYear(),
      detailInfoShow: false,
      detail_info: {
        userInfo: {},
        courseInfo: [],
        examInfo: [],
      },
      userRole: '',
      rateVisible: false,
      rate_lis: [],
    }
  },
  mounted() {
    this.userInfo = this.$store.getters.userInfo
    for (let i = 0; i < this.userInfo.roles.length; i++) {
      if (this.userInfo.roles[i].roleKey == 'youwei_admin') {
        this.userRole = 'youwei_admin'
      }
    }
    this.get_lis()
    this.get_rate()
    this.getDeptLists()
    this.getUserList('')
    console.log(this.userInfo)
    this.$nextTick((res) => {
      this.tableScrollY = this.$refs.mainTable.offsetHeight - 54
    })
  },
  methods: {
    //下拉框查询
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    showMoreRate() {
      manage_more_getrate().then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.rate_lis = res.data
        this.rateVisible = true
      })
    },
    get_lis() {
      manage_getlist(this.searchInfo).then((res) => {
        if (res.code != 200) {
          return
        }
        this.dataLis = res.data.list
        this.totalCount = res.data.totalCount
      })
    },
    get_rate() {
      manage_getrate().then((res) => {
        if (res.code != 200) {
          return
        }
        this.completeRate = res.data.completeRate.replace(/%/g, '')
        this.passRate = res.data.passRate.replace(/%/g, '')
      })
    },

    getUserList(deptId) {
      manage_getlist({ deptId: deptId }).then((res) => {
        if (res.code != 200) {
          return
        }
        let userLis = res.data.list
        for (let i = 0; i < userLis.length; i++) {
          for (let j = i + 1; j < userLis.length; j++) {
            if (userLis[i].userId == userLis[j].userId) {
              userLis.splice(j, 1)
              j--
            }
          }
        }
        this.userLis = userLis
      })
    },
    getDeptLists() {
      let _this = this
      tree_all().then((res) => {
        let deptLists = []
        if (this.userRole == 'youwei_admin') {
          let data = res.data[0]
          function formatDept(lists) {
            for (let i = 0; i < lists.length; i++) {
              if (
                !_this.userInfo.userPermissions.includes(lists[i].deptId) &&
                !_this.userInfo.userPermissions.includes(String(lists[i].deptId))
              ) {
                lists.splice(i, 1)
                i--
              } else if (lists[i].children && lists[i].children.length) {
                formatDept(lists[i].children)
              }
            }
          }
          formatDept(data)
          this.deptLists = data
        } else {
          res.data[0].forEach((item) => {
            if (item.deptId == this.userInfo.companyId) {
              deptLists = item.children
              this.deptLists = deptLists
            }
          })
        }
      })
    },
    deptchange(e) {
      this.searchInfo.userId = undefined
      this.getUserList(e)
    },
    onShowPageChange(page, pageSize) {
      this.searchInfo.pageIndex = page
      this.get_lis()
    },
    search_lis() {
      this.searchInfo.pageIndex = 1
      this.get_lis()
    },
    detailView(row) {
      getTrainingDetail({ userId: row.userId }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.detailInfoShow = true
        this.detail_info = res.data
      })
    },
    refresh() {
      this.searchInfo.deptId = undefined
      this.searchInfo.userId = undefined
      this.searchInfo.pageIndex = 1
      this.get_lis()
      this.getUserList('')
    },
  },
}
</script>

<style lang="less">
.mangement_page {
  width: 100%;
  height: 100%;
  .flex_box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .showRate {
    width: 100px;
    height: 100px;
    position: relative;
    .rate50,
    .rate100 {
      top: 0;
      left: 0;
      position: absolute;
      width: 100px;
      height: 100px;
      transform: rotate(0deg);
      clip: rect(
        50px,
        100px,
        100px,
        0px
      ); /*这个clip属性用来绘制半圆，在clip的rect范围内的内容显示出来，使用clip属性，元素必须是absolute的 */
      border-radius: 100px;
      background-color: #38b8f2;
      /*-webkit-animation: an1 2s infinite linear; */
    }
    .rate100 {
      background-color: #fff;
    }
    .rateText {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      background: #fff;
      font-size: 20px;
      width: 80px;
      height: 80px;
      border-radius: 40px;
    }
  }
  .ant-btn-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.deptSelectDrop {
  .ant-select-tree-switcher {
    position: relative;
  }
  .ant-select-tree-switcher_open,
  .ant-select-tree-switcher_close {
    &::before {
      content: '';
      position: absolute;
      right: -310px;
      top: 0;
      left: 0;
      bottom: 0;
    }
  }
  .ant-select-tree li {
    overflow-x: hidden;
  }
}
.flex_bet {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>